import ReferenceMaterialCard from './ReferenceMaterialCard';

export default ReferenceMaterialCard;
